import CommonProps from "!!extract-react-types-loader!../../../../../../packages/design-system/button/extract-react-types/new-button/variants/default/common-props";
import LinkButtonProps from "!!extract-react-types-loader!../../../../../../packages/design-system/button/extract-react-types/new-button/variants/default/link-button-props";
import SectionMessage from '@atlaskit/section-message';
import * as React from 'react';
export default {
  CommonProps,
  LinkButtonProps,
  SectionMessage,
  React
};